import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import classNames from 'lib/util/classNames'
import styles from './Group.module.scss'

/**
 * The `Group`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Group (props) {
  const { Tag, children, className, size, ...rest } = props
  const classNameOut = useMemo(
    () =>
      classNames(
        className,
        styles.group,
        styles[`size-${normalizeSizeString(size)}`]
      ),
    [className, size]
  )

  return (
    <Tag className={classNameOut} {...rest}>
      {children}
    </Tag>
  )
}

/** @type {object} */
Group.propTypes = {
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string,
  size: PropTypes.string
}

/** @type {object} */
Group.defaultProps = {
  Tag: 'div',
  className: '',
  size: 'standard'
}

// Memoize
export default memo(Group)
